import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import type { Language } from '../../../../types/language'

const resource = 'languages'

export const requests = {
  fetchLanguages: () => {
    return axiosForGigbaseBiz.get<DataResponse<Language[]>>(resource)
  },
}
